/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import CalendarStrings from "../../constants/calendarStrings";
import MaterialTable from "material-table";
import Moment from "react-moment";
import tableIcons from "../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {makeStyles} from "@material-ui/core/styles";
import {notify} from "../../utils/notify";
import {useMutation, useQuery} from "@apollo/react-hooks";
import PageBar from "../Common/PageBar";
import useLayoutStore from "../../layoutStore";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import {
    ADD_CONTACTS_TO_CONTACT_LISTS,
    GET_CONTACT_LIST_CONTACTS,
    REMOVE_CONTACTS_FROM_CONTACT_LISTS
} from "../../database/queries/contactListQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
    },
}));

const ContactListContacts = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [selectedObj, setSelectedObj] = useState({});
    const [contactListContacts, setContactListContacts] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [globalLayoutState] = useLayoutStore();
    let {url} = useRouteMatch();

    const columns = [
        {
            title: 'Name',
            width: '25%',
            field: 'displayName',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Linkedin Id',
            width: '15%',
            field: 'contactLinkedinId',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Last Updated',
            width: '20%',
            render: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Tags',
            width: '40%',
            render: r => {
                if (r.tags) {
                    return <span>{r.tags.map(tag => tag.tag).join(', ')}</span>
                }
            },
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
    ];

    const {loading: getContactListContactsLoading, error: getContactListContactsError, data: getContactListContactsData, refetch: getContactListContactsRefetch} = useQuery(GET_CONTACT_LIST_CONTACTS, {
        skip: !props.editId,
        variables: {
            contactListId: props.editId,
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            orderList: ['contacts.contact_last_name ASC', 'contacts.contact_first_name ASC']
        },
    });

    const [addContactsToContactLists] = useMutation(ADD_CONTACTS_TO_CONTACT_LISTS);
    const [removeContactsFromContactLists] = useMutation(REMOVE_CONTACTS_FROM_CONTACT_LISTS);

    const handleSearch = (s) => {
        setSearchStr(s);
        getContactListContactsRefetch();
    };

    const handleRefresh = () => {
        getContactListContactsRefetch();
    };

    const handleCopyToContactLists = (contactLists) => {
        const selectedContactListIds = contactLists.map(row => row.contactListId);
        const selectedContactIds = selectedRows.map(row => row.contactId);

        addContactsToContactLists({
            variables: {contactIdList: selectedContactIds, contactListIdList: selectedContactListIds}
        }).then(addContactsToContactListsResult => {
            notify('addContactsToContactLists', addContactsToContactListsResult.data.addContactsToContactLists.returnCode === 0 ? 'info' : 'error', addContactsToContactListsResult.data.addContactsToContactLists.message);
            getContactListContactsRefetch();
        }).catch(e => {
            notify('addContactsToContactLists', 'error', e.message);
            getContactListContactsRefetch();
        });
    };

    const handleMoveToContactLists = (oldContactLists, newContactLists) => {
        const oldContactListIds = oldContactLists.map(row => row.contactListId);
        const newContactListIds = newContactLists.map(row => row.contactListId);
        const selectedContactIds = selectedRows.map(row => row.contactId);

        addContactsToContactLists({
            variables: {contactIdList: selectedContactIds, contactListIdList: newContactListIds}
        }).then(addContactsToContactListsResult => {
            if (addContactsToContactListsResult.data.addContactsToContactLists.returnCode === 0) {
                removeContactsFromContactLists({
                    variables: {contactIdList: selectedContactIds, contactListIdList: oldContactListIds}
                }).then(removeContactsFromContactListsResult => {
                    if (removeContactsFromContactListsResult.data.removeContactsFromContactLists.returnCode === 0) {
                        notify('handleMoveToContactLists', 'info', 'Contacts moved successfully');
                    } else {
                        notify('handleMoveToContactLists', 'error', 'Problem moving contacts');
                    }
                    getContactListContactsRefetch();
                }).catch(e => {
                    notify('removeContactsFromContactLists', 'error', e.message);
                    getContactListContactsRefetch();
                });
            } else {
                notify('handleMoveToContactLists', 'error', 'Problem moving contacts');
                getContactListContactsRefetch();
            }
        }).catch(e => {
            notify('addContactsToContactLists', 'error', e.message);
            getContactListContactsRefetch();
        });
    };

    const handleRemoveFromContactList = () => {
        const selectedContactListIds = [contactListContacts.contactListId];
        const selectedContactIds = selectedRows.map(row => row.contactId);

        removeContactsFromContactLists({
            variables: {contactIdList: selectedContactIds, contactListIdList: selectedContactListIds}
        }).then(removeContactsFromContactListsResult => {
            notify('removeContactsFromContactLists', removeContactsFromContactListsResult.data.removeContactsFromContactLists.returnCode === 0 ? 'info' : 'error', removeContactsFromContactListsResult.data.removeContactsFromContactLists.message);
            getContactListContactsRefetch();
        }).catch(e => {
            notify('removeContactsFromContactLists', 'error', e.message);
            getContactListContactsRefetch();
        });
    };

    useEffect(() => {
        if (getContactListContactsData && getContactListContactsData.contactListContacts) {
            setSelectedRows([]);
            setSelectedObj({});
            setContactListContacts(getContactListContactsData.contactListContacts[0]);
        }
    }, [getContactListContactsData]);

    useEffect(() => {
        if (getContactListContactsError) notify('getContactListContactsError', 'error', getContactListContactsError.message);
    }, [getContactListContactsError]);

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    title={contactListContacts.contactListName + " Members"}
                    handleSearch={handleSearch}
                    handleRefresh={handleRefresh}
                    handleCopyToContactLists={handleCopyToContactLists}
                    copyToContactListDisabled={selectedRows.length === 0}
                    handleMoveToContactLists={handleMoveToContactLists}
                    moveToContactListDisabled={selectedRows.length === 0}
                    handleRemoveFromContactList={handleRemoveFromContactList}
                    removeFromContactListDisabled={selectedRows.length === 0}
                    currentContactLists={[{contactListId: contactListContacts.contactListId}]}
                    showLoading={getContactListContactsLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    {contactListContacts && contactListContacts.contacts && (
                        <SizeMe>
                            {({size}) => {
                                let height = size.height;
                                if (!height) height = window.innerHeight;

                                const tableOptions = {
                                    actionsColumnIndex: -1,
                                    header: true,
                                    maxBodyHeight: height - (globalLayoutState.tabBarHeight + 220),
                                    padding: 'dense',
                                    paging: false,
                                    selection: true,
                                    toolbar: false,
                                };

                                return (<MaterialTable
                                    columns={columns}
                                    data={contactListContacts.contacts}
                                    icons={tableIcons}
                                    options={tableOptions}
                                    title='Contacts'
                                    onSearchChange={(str) => {
                                        setSearchStr(str);
                                    }}
                                    onSelectionChange={(rows) => {
                                        setSelectedRows(rows);
                                        if (rows.length === 1) {
                                            setSelectedObj(rows[0])
                                        } else {
                                            setSelectedObj({})
                                        }
                                    }}
                                />);
                            }}
                        </SizeMe>
                    )}
                </div>
            </Route>}
        </Switch>
    );
};

export default ContactListContacts;
